/* eslint-disable no-restricted-syntax */
import KbaseLayout from 'hpscoutso/components/layout/KbaseLayout'

export default {
  /* ---------------------------------- COMMON ------------------------------- */

  isProd: (import.meta.env.NODE_ENV || 'development') === 'production',
  isDev: (import.meta.env.NODE_ENV || 'development') === 'development',
  allowedExtensions: (import.meta.env.VITE_ALLOWED_EXTENSIONS || '').split(','),
  proxy: (import.meta.env.VITE_USE_PROXY || 'true') === 'true',
  region: true,
  translateView: '1443',
  privateKey: 'ineedhp',

  appIdentifier: {
    id: import.meta.env.VITE_APP_ID || '',
    ownerId: import.meta.env.VITE_OWNER_ID || '',
  },

  /* ---------------------------------- URL ------------------------------- */
  onboardingService: {
    wsServer: import.meta.env.VITE_WS_ONBOARDING || '',
  },
  dialerService: {
    wsServer: import.meta.env.VITE_WS_DIALLER || '',
  },
  partner360Service: {
    wsServer: import.meta.env.VITE_WS_PARTNER360 || '',
    http: import.meta.env.VITE_HTTPS_PARTNER_360 || '',
    notification: import.meta.env.VITE_NOTIFIER_SERVICE || '',
  },
  jiraService: {
    wsServer: import.meta.env.VITE_WS_JIRA || '',
    httpServer: import.meta.env.VITE_HTTP_JIRA || '',
  },
  msTeamsService: {
    httpServer: import.meta.env.VITE_HTTPS_MSTEAM || '',
  },
  omnicomService: {
    wsServer: import.meta.env.VITE_WS_OMNICOM || '',
  },
  messagesService: {
    wsServer: import.meta.env.VITE_WS_MESSAGES || '',
  },
  kbaseService: {
    httpServer: import.meta.env.VITE_HTTPS_KBASE || '',
  },
  httpsServices: {
    onboarding: import.meta.env.VITE_HTTPS_ONBOARDING || '',
    partner360: import.meta.env.VITE_HTTPS_PARTNER_360 || '',
    dataflowx: import.meta.env.VITE_HTTPS_DATAFLOWX || '',
    /** service-promotions. Empty → the Click&Go promotions list stays on its mocks. */
    promotions: import.meta.env.VITE_HTTPS_PROMOTIONS || '',
  },
  /**
   * Dev-only override of the reference date the promotions list is evaluated as
   * of: sent to service-promotions as `endsAfter`, and used to decide whether a
   * promotion is upcoming or active. The FDL sample is stale, so a date behind
   * the deal windows is needed to see anything locally.
   *
   * Guarded by `import.meta.env.DEV`: a production build always sends today.
   */
  promotionsActiveOn: (import.meta.env.DEV && import.meta.env.VITE_PROMOTIONS_ACTIVE_ON) || '',
  wsServices: import.meta.env.VITE_WS_SERVERS,
  dataServerUrl: import.meta.env.VITE_APP_DESIGNER_URL || '',
  rfbDataServerUrl: import.meta.env.VITE_RFB_URL || '',
  pfpFormServerUrl: import.meta.env.VITE_PFP_FORM_SERVER_URL || '',
  bpFormServerUrl: import.meta.env.VITE_PFP_FORM_SERVER_URL || '',
  wwPlannerUrl: import.meta.env.VITE_WW_PLANNER || '',
  authProviderUrl: '/mbe/api/v2/login/providers/hpid',
  passportEndpoint: '/mbe/api/v2/access/token/by/passport',
  authSessionUrl: '/form/view/839',
  sentryDSN: import.meta.env.VITE_SENTRY_DSN || '',
  kbaseUrl: 'https://knowledge.spa.itcs.hp.com',
  amplifyImpactComponentsUrl: import.meta.env.VITE_AMPLIFY_IMPACT_WEB_COMPONENTS || '',

  /* ---------------------------------- GOOGLE ANALYTICS ------------------------------- */

  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || '',
  googleAnalyticsIdOLD: import.meta.env.VITE_GOOGLE_ANALYTICS_ID_OLD || '',
  googleApiKey: import.meta.env.VITE_GOOGLE_API_KEY || '',

  /* ---------------------------------- MS GRAPH ------------------------------- */

  msFormAuth: {
    tenantId: import.meta.env.VITE_MS_TENANT_ID || '',
    clientId: import.meta.env.VITE_MS_CLIENT_ID || '',
  },

  msGraphSettings: {
    appId: 'b87e3d9b-afd9-4734-b09d-0607d0a631a3',
    redirectUri: 'http://localhost:3000',
    wsServer: 'ws://localhost:8002',
    scopes: [
      'calendars.read',
      'User.Read.All',
      'User.ReadWrite.All',
      'Group.Read.All',
      'Group.ReadWrite.All',
      'Chat.Read',
      'Chat.ReadWrite',
      'Mail.Read',
      'ChannelMessage.Read.All',
    ],
    defaultTeamId: 'fb087f11-524b-401d-bdeb-f2c4ca1e869f',
    defaultChannelId: '19:b69451db6cbd490e9d87cdf1e4538f29@thread.skype',
  },

  /* ---------------------------------- LAYOUT ------------------------------- */

  sitePagesSettings: [
    {
      name: 'horizontal',
      template: 'legacy/lut/components/layout/WidgetsLut',
      properties: {},
    },
    {
      name: 'horizontalFlex',
      template: 'legacy/lut/components/layout/WidgetsLut',
      properties: {},
    },
    {
      name: 'Onboarding',
      template: 'legacy/lut/components/layout/OnboardingLayout',
      properties: {},
    },
    {
      name: 'OnboardingError',
      template: 'legacy/lut/components/layout/OnboardingErrorLayout',
      properties: {},
    },
    {
      name: 'BusinessPartnerRegistrationError',
      template: 'legacy/lut/components/layout/BPErrorLayout',
      properties: {},
    },
    {
      name: 'default',
      template: 'legacy/lut/components/layout/WidgetsLut',
      properties: {},
    },
    {
      name: 'noFooter',
      template: 'legacy/lut/components/layout/LayoutNoFooter',
      properties: {},
    },
    {
      name: 'noHeaderFooter',
      template: 'legacy/lut/components/layout/NoHeaderFooter',
      properties: {},
    },
    {
      name: 'Registration',
      template: 'hpscoutso/components/layout/RegistrationLayout',
      properties: {},
    },
    {
      name: 'kbase',
      template: 'hpscoutso/components/layout/KbaseLayout',
    },
    {
      name: 'Gray background',
      template: 'legacy/lut/components/layout/GrayLayout',
      properties: {},
    },
    {
      name: 'Gray background Without Footer',
      template: 'legacy/lut/components/layout/GrayLayoutWithoutFooter',
      properties: {},
    },
    {
      name: 'White background',
      template: 'legacy/lut/components/layout/WhiteLayout',
      properties: {},
    },
    {
      name: 'RCP Layout',
      template: 'legacy/lut/components/layout/RcpLayout',
      properties: {},
    },
  ],
}
